import clsx from "clsx";

import { OptionalTooltip } from "@/components/OptionalTooltip";
import { Row } from "@/components/Row";
import { Badge } from "@/components/ui/badge";

import { jobStatusToDotColor, jobStatusToLabel } from "@/lib/constants";
import { jobs } from "@/lib/jobs";
import { JobPauseType, JobStatus } from "@/types";

export const JobStatusBadge = ({
  className,
  pausedAt,
  pauseReason,
  pauseType,
  status,
}: {
  className?: string;
  pausedAt: string | null;
  pauseReason: string | null;
  pauseType: JobPauseType | null;
  status: JobStatus;
}) => {
  const showPaused = jobs.isDisplayPaused(status, pausedAt);
  return (
    <OptionalTooltip
      text={
        showPaused
          ? jobs.pausedTooltip(pausedAt, pauseReason, pauseType)
          : undefined
      }
      trackingLabel="Paused job tooltip"
    >
      {/* Row wrapper: Badge doesn't forward refs, which the tooltip trigger's
          asChild requires. Callers' className lands here so layout utilities
          (e.g. ml-auto) apply to the outermost element. */}
      <Row className={className}>
        <Badge className="gap-2 text-sm" variant="outline">
          <div
            className={clsx(
              "h-3 w-3 rounded-full",
              showPaused
                ? jobs.pauseDotColor(pauseType)
                : jobStatusToDotColor[status],
            )}
          />
          <p>
            {showPaused ? jobs.pauseLabel(pauseType) : jobStatusToLabel[status]}
          </p>
        </Badge>
      </Row>
    </OptionalTooltip>
  );
};
